import { useQuery, useMutation } from 'react-query'
import { getAccountGovernanceConnections } from '../api/account'
import useAccountQueries from '../api/accountQueries'

// Query keys
const queryKeys = {
  connections: ['accountGovernanceConnections'] as const
}

export const useAccountGovernanceConnections = () => {
  return useQuery({
    queryKey: queryKeys.connections,
    queryFn: getAccountGovernanceConnections,
    // No cache time, we want to fetch the data every time
    cacheTime: 0
  })
}

export const useUpdateAccountGovernanceConnections = () => {
  const { queries } = useAccountQueries()
  return useMutation(queries.updateAccountGovernanceConnections)
}
